module.exports = __webpack_public_path__ + "cw.svg?5e1e838d56f64ef7953dba5b1aafac57";